(function() {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    /**
     * This service is used to manage interactions between various controllers.
     * If controller A needs to inform controller B of an action taking place
     * and you wish to do so without passing data our in broadcasts and emits,
     * this service should be used to do so. Register a callback in the destination,
     * and notify the observer from the source.
     *
     * @params $timeout - inject the default angular $timeout service
     */
    angular
        .module('ihh-common-web')
        .service('ObserverService', ObserverService);

    ObserverService.$inject = ['$timeout'];

    function ObserverService($timeout) {
        var self = this;
        var observerCallbacks = {};

        self.notifyObservers = function(key, args) {
            if (angular.isFunction(observerCallbacks[key])) {
                $timeout(function () {
                    observerCallbacks[key](args);
                });
            }
        };

        self.registerObserverCallback = function(key, callback) {
            observerCallbacks[key] = callback;
        };

        self.deregisterObserverCallback = function (key) {
            delete observerCallbacks[key];
        };

        return self;
    }
})();